import React from "react";
import Img1 from "../assets/images/hero/transforming-india.png";
import Bg1 from "../assets/images/bg/bg1.png";
import { Link } from "react-router-dom";
import HeroCarousel from "../components/carousel/HeroCarousel";
import FeatureSection from "../components/FeatureSection";
import ScrollFeatureSection from "../components/ScrollFeatureSection";
import FlipCardSlider from "../components/Slider/FlipCardSlider";
import CardSlider from "../components/Slider/CardSlider";
import GSAPFeatureSection from "../components/GSAPFeatureSection";
import NewFeatures from "../components/NewFeatures";
import VisionImg from "../assets/32.svg";
import ViewImg from "../assets/33.png";
import AnimatedCarousel from "../components/carousel/AnimatedCarousel";
import Card from "../components/Card/Card";
import CardContainer from "../components/Card/CardContainer";
import GSAPProductReveal from "../components/Product/GSAPProductReveal";
const Landing = () => {
  const heroSlides = [
    {
      bg: "images/hero/2.webp",
      // textImg: "images/hero/text1.webp",
      buttonText: "Learn More",
      buttonLink: "#",
    },
    {
      bg: "images/hero/3.webp",
      // textImg: "images/hero/text2.webp",
      buttonText: "Learn More",
      buttonLink: "#",
    },
    {
      bg: "images/hero/5.webp",
      // textImg: "images/hero/text3.webp",
      buttonText: "Learn More",
      buttonLink: "#",
    },
  ];

  const features = [
    {
      title: "Smoking Warning",
      description: "Detects when the driver is smoking and issues an audio warning",
      videoSrc: "http://shoora.com/video/Smoking.mp4",
      backgroundImage: 'https://cdn.pixabay.com/photo/2016/11/21/16/37/loader-1846346_1280.jpg'
    },
    {
      title: "Driver Posture Warning",
      description: " Reminds drivers to stay focused when they become distracted by detecting wrong posture",
      videoSrc: "http://shoora.com/video/Distraction.mp4",
      backgroundImage: 'https://cdn.pixabay.com/photo/2017/11/05/14/01/truck-2920533_1280.jpg'
    },
    {
      title: "Frontal Collision Alert",
      description: "Alerts drivers to potential forward collisions",
      videoSrc: "http://shoora.com/video/Car-Close-Distance.mp4",
      backgroundImage: 'https://cdn.pixabay.com/photo/2019/08/15/17/56/production-4408573_1280.jpg'
    },
    {
      title: "Mobile Usage Alert",
      description: "Encourages drivers to put down their phones while driving",
      videoSrc: "http://shoora.com/video/FCW.mp4",
      backgroundImage: 'https://cdn.pixabay.com/photo/2023/01/07/11/54/quarries-7703098_1280.jpg'
    },
    {
      title: "Proximity Alert",
      description: "Detects and trains drivers who follow other vehicles too closely",
      videoSrc: "http://shoora.com/video/FCW.mp4",
      backgroundImage: 'https://cdn.pixabay.com/photo/2023/01/07/11/54/quarries-7703098_1280.jpg'
    },
    {
      title: "Driver Attention Monitoring",
      description: "Reminds drivers to stay focused and keep their eyes on the road",
      videoSrc: "http://shoora.com/video/FCW.mp4",
      backgroundImage: 'https://cdn.pixabay.com/photo/2023/01/07/11/54/quarries-7703098_1280.jpg'
    },
  ];
  return (
    <>
      {/* <HeroCarousel slides={heroSlides} /> */}
      
 

      <GSAPProductReveal/>

    </>
  );
};

export default Landing;
